import styled from 'styled-components';

export const QuestionnaireFooterBackButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  font-weight: 500;

  button {
    min-height: 40px;
  }
`;
